/** Ingliz lug'ati: asosiy manba. Har sahifa o'z namespace'ini shu yerga qo'shadi. */
const en = {
  common: {
    app: "FATH TIME Logistics",
    nav: {
      dashboard: "Dashboard", tasks: "Tasks", drivers: "Drivers", pipeline: "Pipeline", carriers: "Carriers", jobs: "Jobs",
      approvals: "Approvals", reports: "Reports", budget: "Budget", admin: "Admin", notifications: "Notifications", profile: "My profile", logout: "Logout",
      myPage: "My page", profileSecurity: "Profile & security",
      today: "Today", overview: "Overview", people: "People", team: "Team", finance: "Finance", settings: "Settings",
      board: "Board", list: "List",
      collapse: "Collapse sidebar", expand: "Expand sidebar", pin: "Keep menu open", unpin: "Collapse menu",
    },
    search: "Search name, phone, CDL #",
    allBranches: "All branches",
    myBranches: "All my branches",
    offline: "Offline", reconnecting: "Reconnecting…", liveUpdatesPaused: "Live updates paused",
    language: "Language",
    theme: { dark: "Dark mode", light: "Light mode" },
    appearance: { title: "Appearance", light: "Light", dark: "Dark", system: "Auto" },
    scope: { label: "Branch", all: "All" },
    palette: {
      placeholder: "Search drivers, people, carriers, jobs… or type a command", searchButton: "Search (⌘K)", actions: "Actions", recent: "Recent drivers", goTo: "Go to",
      addDriver: "Add driver", addDriverHint: "name, phone, CDL", newJob: "New job", newReminder: "New reminder", showAll: "Show all {{count}}", similar: "similar",
      noResults: "Nothing found", hint: "↑↓ navigate · ↵ open · esc close", searching: "Searching…",
    },
    actions: {
      save: "Save", saveChanges: "Save changes", cancel: "Cancel", copy: "Copy", edit: "Edit", delete: "Delete", archive: "Archive", restore: "Restore",
      close: "Close", back: "Back", next: "Next", submit: "Submit", confirm: "Confirm", approve: "Approve", reject: "Reject", done: "Done",
      undo: "Undo", retry: "Retry", add: "Add", create: "Create", search: "Search", filter: "Filter", clearFilters: "Clear filters",
      export: "Export", refresh: "Refresh", view: "View", open: "Open", send: "Send", apply: "Apply", select: "Select…", choose: "Choose",
    },
    states: {
      loading: "Loading…", saving: "Saving…", noResults: "No results", nothingHere: "Nothing here yet", error: "Something went wrong.",
      notFound: "Page not found", notFoundHint: "The page you are looking for does not exist.", backHome: "Back to Dashboard",
      required: "Required", optional: "Optional", yes: "Yes", no: "No", on: "On", off: "Off", all: "All", none: "—",
    },
    select: { search: "Search…", similar: "No exact match — showing similar" },
    table: { of: "of", rowsPerPage: "Rows per page", page: "Page", showing: "Showing {{from}}–{{to}} of {{count}}" },
    time: { today: "Today", yesterday: "Yesterday", tomorrow: "Tomorrow", overdue: "Overdue", daysLate: "{{count}} days late", inDays: "in {{count}} days" },
    driverType: {
      company_solo: "Company · Solo", company_team: "Company · Team", lease_solo: "Lease · Solo", lease_team: "Lease · Team",
      owner_solo: "Owner · Solo", owner_team: "Owner · Team", training: "Training", co_driver: "Co-driver",
      company: "Company", lease: "Lease", owner: "Owner", team: "Team",
    },
    hiringType: { company: "Company", lease: "Lease", owner: "Owner-operator", team: "Team" },
    freight: { amazon: "Amazon", street: "Street", both: "Amazon and street" },
    fee: { pending: "Waiting", overdue: "Overdue", paid: "Paid", partial: "Partially paid", not_paid: "Not paid", awaitingApproval: "Awaiting hire approval" },
    roles: { owner: "Owner", branch_manager: "Branch manager", recruiter: "Recruiter", carrier: "Carrier" },
    status: {
      new: "New", contacted: "Contacted", qualified: "Qualified", docs: "Docs", submitted: "Submitted", background_check: "Background check",
      orientation: "Orientation", hired: "Hired", rejected: "Rejected", not_interested: "Not interested", quit: "Quit",
      open: "Open", filled: "Filled", closed: "Closed", active: "Active", paused: "Paused", stopped: "Stopped",
      pending: "Pending", approved: "Approved", draft: "Draft", paid: "Paid", in_review: "In review", accepted: "Accepted", available: "Available", assigned: "Assigned", in_shop: "In shop", inactive: "Inactive", blocked: "Blocked",
    },
    source: { facebook: "Facebook", indeed: "Indeed", referral: "Referral", craigslist: "Craigslist", telegram: "Telegram", apply_form: "Apply form", import: "Sheets import", other: "Other" },
    legalStatus: { citizen: "US Citizen", green_card: "Green Card", work_permit: "Work Permit (EAD)", non_domiciled: "Non-domiciled", other: "Other" },
    reminder: { call_back: "Call back", send_docs: "Send docs", follow_up: "Follow up", cdl_expiry: "CDL expiry", medical_expiry: "Medical card expiry", retention_check: "Retention check" },
    localTime: {
      label: "Local time {{time}}",
      open: "call hours, {{left}} left",
      opensIn: "call hours start in {{wait}}",
      hm: "{{h}} h {{m}} min",
      m: "{{m}} min",
      titleOpen: "Driver's local time · within call hours ({{from}}–{{to}})",
      titleClosed: "Driver's local time · outside call hours ({{from}}–{{to}})",
    },
    toast: {
      saved: "Saved", updated: "Updated", created: "Created", deleted: "Archived", conflict: "Changed by {{who}}. Reloaded.", conflictAnon: "Changed by someone else. Reloaded.",
      failed: "Could not save", permission: "You do not have permission to do this.",
    },
    update: { title: "A new version is installed", desc: "The page refreshes on your next navigation; nothing you are typing is lost until then.", reload: "Refresh now" },
    appError: { title: "Something went wrong", desc: "Refresh the page. If it happens again, tell the owner what you were doing.", reload: "Refresh", home: "Home page" },
    errors: { checkFields: "Check the highlighted fields.", requiredField: "This field is required.", invalidEmail: "Enter a valid email.", invalidPhone: "Enter a valid phone number.", languageNotSaved: "Couldn't save the language. Check your connection and try again." },
    version: { changedBy: "Changed by {{who}}", reload: "Reload" },
    periods: { quarter: "Q{{q}} {{year}}" },
    units: { hires: "hires", hires_one: "hire", drivers: "drivers", days: "days", months: "months", years: "years", yr: "yr", yrs: "yrs", mo: "mo" },
  },
};
export default en;
export type Resources = typeof en;
